import styled from 'styled-components';

export default styled.p`
  font-size: 1.4rem;
  color: #738a94;
  margin: 4rem 0 0 0;
  line-height: 1.7;
  align-self: end;
  width: 100%;
`;
